// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7a8adfa3","455":"f66cd33b","488":"e80196f3","977":"9d59ef55"}[chunkId] + ".chunk.js";
};